import 'reflect-metadata';
import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Activite, BaseEntite, EntiteStatique } from './index';

@EntiteStatique()
@Entity('thematique')
export class Thematique implements BaseEntite {
    static key = 'thematique';

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @ManyToOne(() => Activite, (activite: Activite) => activite.thematiques)
    @JoinColumn({ name: 'fk_id_activite', referencedColumnName: 'id' })
    activite: Activite;

    @Column({ nullable: true })
    fk_id_activite: number;

    @Column({ type: 'timestamp', nullable: true })
    debut: string;

    @Column({ type: 'timestamp', nullable: true })
    fin: string;

    @Column({ nullable: true })
    description: string;

    @Column({ nullable: true })
    ordreAffichage: number;

    @Column({ nullable: true, default: true })
    est_public: boolean;
}
